import { REPORT_CONSTANTS } from "../config/constants";
import type { ReportDocumentProps } from "../hooks/useReportPDF";

/**
 * Checks if a value is a ReportDataCombined object
 */
export function isReportDataCombined(value: unknown): boolean {
  if (!value || typeof value !== 'object') return false;
  const obj = value as Record<string, unknown>;
  return (
    Array.isArray(obj.combined_data) ||
    Array.isArray(obj.report_sources_data)
  );
}

/**
 * Extracts only combined_data from combinado report sections
 * This reduces payload size by not sending report_sources_data
 */
export function extractCombinedData(props: ReportDocumentProps): ReportDocumentProps {
  const reportType = props.metadata?.[REPORT_CONSTANTS.new_report.report_type];

  // Only process combinado reports
  if (reportType !== REPORT_CONSTANTS.types.combinado) {
    return props;
  }

  const { sections, ...rest } = props;

  // Check if sections contains the combinado structure
  if (!Array.isArray(sections) || sections.length === 0) {
    return props;
  }

  // The combinado payload may wrap everything in an array with a single object
  const firstItem = sections[0];

  if (isReportDataCombined(firstItem)) {
    const combinedDataContainer = firstItem as any;

    if (Array.isArray(combinedDataContainer.combined_data)) {
      return {
        ...rest,
        sections: combinedDataContainer.combined_data
      };
    }
  }

  return props;
}